import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface exportCustomDeviceDataState {
  isLoading: boolean
  loadingError: string | null
  exportCustomDeviceData: any
}

// Initial state of the slice
const initialState: exportCustomDeviceDataState = {
  isLoading: true,
  loadingError: null,
  exportCustomDeviceData: null
}

// Slice to return from action
export const exportCustomDeviceDataSlice = createSlice({
  name: 'exportDeviceDataGraph',
  initialState,
  reducers: {
    exportCustomDeviceDataLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        isLoading: true,
        loadingError: null,
        exportCustomDeviceData: []
      }
    },
    exportCustomDeviceDataUpdateAction: (state, action: PayloadAction< any >) => {
      return {
        isLoading: false,
        loadingError: null,
        exportCustomDeviceData: action.payload
      }
    },
    exportCustomDeviceDataErrorAction: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        isLoading: false,
        loadingError: action.payload,
        exportCustomDeviceData: null
      }
    }
  }
})

// Actions to export
export const {
  exportCustomDeviceDataLoadingAction,
  exportCustomDeviceDataUpdateAction,
  exportCustomDeviceDataErrorAction
} = exportCustomDeviceDataSlice.actions

export default exportCustomDeviceDataSlice.reducer
